import { selectCurrentCourse } from '../../../../db/courses/selectors';
import { useAppSelector } from '../../../../store/hooks';

const useRightActionsVM = () => {
  const currentCourse = useAppSelector((state) => selectCurrentCourse(state));

  return { currentCourse };
};

export default useRightActionsVM;
